<template>
<v-navigation-drawer
          v-model="state"
          @input="stateChange"
          color="primary"
          absolute
          temporary
          dark
        >
          <v-list
            dense
            nav
            class="py-0"
          >
            <v-list-item>
              <b>MENU</b>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              v-for="item in items"
              :key="item.title"
              link
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
      </v-navigation-drawer>
</template>

<script>
export default {
  name: 'NavigationDrawer',
  props: {
    drawer: Boolean
  },
  watch: {
    // We have to watch drawer prop changes and set state variable accordingly
    // We do this to avoid warning when the v-navigation-drawer changes its state variable
    drawer: function () {
      this.state = this.drawer;
    }
  },
  data: () => ({
    state: false,
    items: [
      { title: 'Dashboard', icon: 'mdi-view-dashboard' },
      { title: 'Configuration', icon: 'mdi-cogs' },
      { title: 'Developer Tool', icon: 'mdi-code-braces' }
    ]
  }),
  methods: {
    // Called when the drawer changes state
    stateChange (newstate) {
      // If the drawer is closing, we have to warn the parent component : it has to change the drawer state var as well
      if (!newstate) this.$emit('onDrawerHide');
    }
  }
};
</script>
